import { useEffect } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HighlightsSection from "./components/HighlightsSection";
import AboutPreviewSection from "./components/AboutPreviewSection";
import ContactStrip from "./components/ContactStrip";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "The LittyCity Agency LLC",
  url: import.meta.env.VITE_SITE_URL || "https://example.com",
  logo: "https://static.readdy.ai/image/9bd046423ff55e49be43d604c216515f/748f9bdfc4c6ea0c2a13ac200d412f03.png",
  description:
    "The LittyCity Agency LLC is a full-service multi-platform creator management agency empowering hosts, influencers, and brands across Instagram, TikTok, YouTube, BIGO Live, and more.",
  foundingDate: "2024",
  areaServed: "US",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1-845-370-1756",
    contactType: "customer service",
    availableLanguage: "English",
  },
  sameAs: [],
};

export default function HomePage() {
  useEffect(() => {
    const id = "schema-home";
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SCHEMA);
    document.title =
      "The LittyCity Agency LLC | Multi-Platform Creator & Host Management Agency";
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-brand-black">
      <Navbar />
      <main>
        <HeroSection />
        <HighlightsSection />
        <AboutPreviewSection />
        <ContactStrip />
      </main>
      <Footer />
    </div>
  );
}
